import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../atoms';
import { getBenefitsByCategoryFromPlan } from '../../helpers';
import { BenefitsProgress } from './BenefitsProgress';

export const OrthodonticsSection = () => {
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Get orthodontics benefits from the selected plan's coverage data
  const orthodonticsBenefits = getBenefitsByCategoryFromPlan(
    currentPlan,
    'orthodontics',
  );

  return (
    <div className="vai-space-y-6">
      {/* Orthodontics Benefits */}
      <div className="vai-grid vai-grid-cols-2 vai-gap-8">
        {/* Placeholder for future orthodontics-specific status */}
        <div>
          <div className="vai-text-sm vai-font-medium vai-text-muted-foreground vai-uppercase vai-leading-small">
            <Trans>ORTHODONTICS STATUS</Trans>
          </div>
          <div className="vai-mt-3 vai-text-2xl vai-font-medium vai-text-gray-500">
            <Trans>Coming Soon</Trans>
          </div>
        </div>

        {/* Orthodontics Benefits Remaining */}
        {orthodonticsBenefits.remaining !== undefined &&
          orthodonticsBenefits.total !== undefined && (
            <BenefitsProgress
              progress={orthodonticsBenefits.remaining}
              total={orthodonticsBenefits.total}
              title="ORTHODONTICS BENEFITS REMAINING"
            />
          )}
      </div>
    </div>
  );
};
